export default "__VITE_ASSET__Bw2IoZXp__"